module.exports = __webpack_public_path__ + "cc76d8079b15669d051d2961111cef59.svg";